import React from 'react';
import { MenuItem, TextField } from '@mui/material';
import { FieldGroup } from '../PanelComerciales.styles';
import { Commercial } from '../PanelComerciales.types';
import { VALIDITY_OPTIONS } from '../utils/vipValidity';

/**
 * Campos compartidos por los drawers de VIP (asignar y editar): selector de
 * owner (comercial activo) y selector de vigencia. Centralizar evita repetir
 * la misma estructura de Select en cada drawer.
 */

interface OwnerSelectFieldProps {
    value: number | '';
    commercials: Commercial[];
    onChange: (id: number) => void;
}

export const OwnerSelectField: React.FC<OwnerSelectFieldProps> = ({
    value,
    commercials,
    onChange,
}) => (
    <FieldGroup>
        <label>Owner fijo</label>
        <TextField
            size='small'
            select
            value={value}
            onChange={(e) => onChange(Number(e.target.value))}
        >
            {commercials
                .filter((c) => c.active)
                .map((c) => (
                    <MenuItem key={c.id} value={c.id}>
                        {c.name} ({c.team})
                    </MenuItem>
                ))}
        </TextField>
    </FieldGroup>
);

interface ValiditySelectFieldProps {
    value: string;
    onChange: (next: string) => void;
    helperText?: string;
}

export const ValiditySelectField: React.FC<ValiditySelectFieldProps> = ({
    value,
    onChange,
    helperText,
}) => (
    <FieldGroup>
        <label>Vigencia</label>
        <TextField
            size='small'
            select
            value={value}
            onChange={(e) => onChange(e.target.value)}
            helperText={helperText}
        >
            {VALIDITY_OPTIONS.map((opt) => (
                <MenuItem key={opt} value={opt}>
                    {opt}
                </MenuItem>
            ))}
        </TextField>
    </FieldGroup>
);
